<template>
  <div>
          <BrandImageLink :brand="brandInfo" />
          <EnergyRating
        v-if="hasEnergyRating"
        :energy-rating="attributesLocalized.energyRating"
        class="desktop-only"
      />
          <TrustAccordion
        :attributes-localized="attributesLocalized"
        :manual="manual"
        :sku="product.sku"
        :should-show-related-accessories="!!(shouldShowRelatedAccessories)"
      />
  </div>
</template>

<script lang="ts">

import { defineAsyncComponent } from 'vue';


import type { ProductVariant } from '~~/types/commercetools';
import type { ProductProcessedAttributes } from '~~/types/product/attribute/ProductProcessedAttributes';
import { getBrandInfo } from '~~/helpers/brand';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';

export default defineComponent({
  name: 'ProductQuickDetails',
  components: {
    BrandImageLink: defineAsyncComponent(() => import('~/components/molecules/Product/Brand/BrandImageLink/BrandImageLink.vue')),
    TrustAccordion: defineAsyncComponent(() => import(/* webpackChunkName: "TrustAccordion" */
      '~/components/organisms/Product/TrustAccordion/TrustAccordion.vue')),
    EnergyRating: defineAsyncComponent(() => import(/* webpackChunkName: "EnergyRating" */
      '~/components/molecules/Product/EnergyRating.vue')),
  },
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    attributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
    shouldShowRelatedAccessories: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {

    const brandInfo = computed(() => getBrandInfo(props.attributesLocalized?.brand) || {});
    const hasEnergyRating = computed(() => props.attributesLocalized?.energyRating);
    const manual = computed(() =>
      getProductAttributesExtended(
        props.product,
        {
          attributeNames: [PRODUCT_ATTRIBUTES.MANUAL_URL],
        })[PRODUCT_ATTRIBUTES.MANUAL_URL] || '',
    );

    return {
      brandInfo,
      hasEnergyRating,
      manual,
    };
  
  },
});

</script>
